import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/collection/settlement", { offset, filter });
};

export const send = async (id: string, data: any) => {
  return httpRequest.put(`/api/collection/settlement/${id}/send`, data);
};

export const business = async (data: any) => {
  return httpRequest.get("/api/collection/settlement/business_select", data);
};
